import { MDBContainer, MDBBtn as MDBTN, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import Fastcoin from '../../assets/logo.png';

export const ModalTermos = (props) => {

    console.log('dentro modal');

    return (
        <MDBContainer className='container_modal'>
            <MDBModal isOpen={props.modal} toggle={props.toggle} className='modal-lg'>
                <MDBModalHeader toggle={props.toggle} className="titulo-modal-termo"><span data-lang-str="tittle_termo"> </span></MDBModalHeader>
                <MDBModalBody>
                    <img src={Fastcoin} alt={"Logomarca da fastcoin"} width="100px" height="100px" />
                    <h1><b data-lang-str="terms_cond_M"></b></h1>
                    <p data-lang-str="version_term_M"></p>
                    <h5><b data-lang-str="fastcoin_termo_M"></b></h5>
                    <p data-lang-str="inter_fast_M"></p>
                    <p><b data-lang-str="consid_q"></b></p>
                    <p data-lang-str="consid_q_1"></p>
                    <p><b data-lang-str="consid_q"></b></p>
                    <p data-lang-str="consid_q_2"></p>
                    <p><b data-lang-str="consid_q"></b></p>
                    <p data-lang-str="consid_q_3"></p>
                    <p><b data-lang-str="consid_q"></b></p>
                    <p data-lang-str="consid_q_4"></p>
                    <h5><b data-lang-str="sub_tittle_terms_M"></b></h5>
                    <h4><b data-lang-str="text_termo1"></b></h4>
                    <p data-lang-str="text_termo1_1"></p>
                    <h4><b data-lang-str="text_termo2"></b></h4>
                    <p data-lang-str="text_termo2_2"></p>
                    <h4><b data-lang-str="text_termo3"></b></h4>
                    <p data-lang-str="text_termo3_3"></p>
                    <h4><b data-lang-str="text_termo4"></b></h4>
                    <p data-lang-str="text_termo4_4"></p>
                    <h4><b data-lang-str="text_termo5"></b></h4>
                    <p data-lang-str="text_termo5_1"></p>
                    <p><b data-lang-str="text_termo5_2"></b></p>
                    {/*Política de Privacidade*/}
                    <h3><b data-lang-str="term_privacy"></b></h3>
                    <p><b data-lang-str="ultm_version"></b></p>
                    <p data-lang-str="text_term1"></p>
                    <p><b data-lang-str="text_term2"></b></p>
                    <h5><b data-lang-str="title_1privacy"></b></h5>
                    <p data-lang-str="text_title1"></p>
                    <p data-lang-str="text_title1_1"></p>
                    <p data-lang-str="text_title1_2"></p>
                    <p data-lang-str="text_title1_3"></p>
                    <p data-lang-str="text_title1_4"></p>
                    <p data-lang-str="text_title1_5"></p>
                    <p data-lang-str="text_title1_6"></p>
                    <p data-lang-str="text_title1_7"></p>
                    <p data-lang-str="text_title1_8"></p>
                    <p data-lang-str="text_title1_9"></p>
                    <p data-lang-str="text_title1_10"></p>
                    <p data-lang-str="text_title1_11"></p>
                    <p><b data-lang-str="text_title1_12"></b></p>
                    <h5><b data-lang-str="title_2privacy"></b></h5>
                    <p><b data-lang-str="text_title2"></b></p>
                    <h5><b data-lang-str="title_3privacy"></b></h5>
                    <p><b data-lang-str="text_title3"></b></p>
                    <p data-lang-str="text_title3_1"></p>
                    <p data-lang-str="text_title3_2"></p>
                    <p data-lang-str="text_title3_3"></p>
                    <h5><b data-lang-str="title_4privacy"></b></h5>
                    <p><b data-lang-str="text_title4"></b></p>
                    <p data-lang-str="text_title4_1"></p>
                    <p data-lang-str="text_title4_2"></p>
                    <p data-lang-str="text_title4_3"></p>
                    <p data-lang-str="text_title4_4"></p>
                    <p data-lang-str="text_title4_5"></p>
                    <p data-lang-str="text_title4_6"></p>
                    <p data-lang-str="text_title4_7"></p>
                    <p data-lang-str="text_title4_8"></p>
                    <p data-lang-str="text_title4_9"></p>
                    <h5><b data-lang-str="title_5privacy"></b></h5>
                    <p><b data-lang-str="text_title5"></b></p>
                    <p data-lang-str="text_title5_1"></p>
                    <p data-lang-str="text_title5_2"></p>
                    <p data-lang-str="text_title5_3"></p>
                    <p data-lang-str="text_title5_4"></p>
                    <p data-lang-str="text_title5_5"></p>
                    <p data-lang-str="text_title5_6"></p>
                    <p data-lang-str="text_title5_7"></p>
                    <p data-lang-str="text_title5_8"></p>
                    <p data-lang-str="text_title5_9"></p>
                    <p data-lang-str="text_title5_10"></p>
                    <p data-lang-str="text_title5_11"></p>
                    <p data-lang-str="text_title5_12"></p>
                    <p data-lang-str="text_title5_13"></p>
                    <p data-lang-str="text_title5_14"></p>
                    <p data-lang-str="text_title5_15"></p>
                    <p data-lang-str="text_title5_16"></p>
                    <p data-lang-str="text_title5_17"></p>
                    <p data-lang-str="text_title5_18"></p>
                    <p data-lang-str="text_title5_19"></p>
                    <p data-lang-str="text_title5_20"></p>
                    <p data-lang-str="text_title5_21"></p>
                    <p data-lang-str="text_title5_22"></p>
                    <p data-lang-str="text_title5_23"></p>
                    <p data-lang-str="text_title5_24"></p>
                    <p data-lang-str="text_title5_25"></p>
                    <p data-lang-str="text_title5_26"></p>
                    <p data-lang-str="text_title5_27"></p>
                    <p data-lang-str="text_title5_28"></p>
                    <p data-lang-str="text_title5_29"></p>
                    <p data-lang-str="text_title5_30"></p>
                    <p data-lang-str="text_title5_31"></p>
                    <h5><b data-lang-str="title_6privacy"></b></h5>
                    <p><b data-lang-str="text_title6"></b></p>
                    <p data-lang-str="text_title6_1"></p>
                    <p data-lang-str="text_title6_2"></p>
                    <p data-lang-str="text_title6_3"></p>
                    <h5><b data-lang-str="title_7privacy"></b></h5>
                    <p><b data-lang-str="text_title7"></b></p>
                    <p data-lang-str="text_title7_1"></p>
                    <p data-lang-str="text_title7_2"></p>
                    <p data-lang-str="text_title7_3"></p>
                    <p data-lang-str="text_title7_4"></p>
                    <p data-lang-str="text_title7_5"></p>
                    <p data-lang-str="text_title7_6"></p>
                    <p data-lang-str="text_title7_7"></p>
                    <h5><b data-lang-str="title_8privacy"></b></h5>
                    <p><b data-lang-str="text_title8"></b></p>
                    <p data-lang-str="text_title8_1"></p>
                    <p data-lang-str="text_title8_2"></p>
                    <p data-lang-str="text_title8_3"></p>
                    <h5><b data-lang-str="title_9privacy"></b></h5>
                    <p><b data-lang-str="text_title9"></b></p>
                    <p data-lang-str="text_title9_1"></p>
                    <p data-lang-str="text_title9_2"></p>
                    <p data-lang-str="text_title9_3"></p>
                    <p data-lang-str="text_title9_4"></p>
                    <p data-lang-str="text_title9_5"></p>
                    <p data-lang-str="text_title9_6"></p>
                    <h5><b data-lang-str="title_10privacy"></b></h5>
                    <p data-lang-str="text_title10_1"></p>
                    <p data-lang-str="text_title10_2"></p>
                    <p data-lang-str="text_title10_3"></p>
                    <h5><b data-lang-str="title_11privacy"></b></h5>
                    <p data-lang-str="text_title11"></p>
                    <p><b data-lang-str="text_title11_1"></b></p>
                </MDBModalBody>
                <MDBModalFooter>
                    {/* {!props.doc &&
                        <p style={{color: 'red'}}>{props.getStrLang(props.lang.nameLang, "id_please")}</p>
                    }
                    <MDBTN disabled={!props.doc} color="success" onClick={() => props.aceitetermos(true)}>{props.getStrLang(props.lang.nameLang, "btn_aceitar")}</MDBTN> */}
                </MDBModalFooter>
            </MDBModal>
        </MDBContainer>
    )
}